// extracted by mini-css-extract-plugin
module.exports = {"slide":"AddressForm_slide_3Gvqt","slide-reverse":"AddressForm_slide-reverse_3ag7F","orderformSection":"AddressForm_orderformSection_lk4EO"};